import { useEffect, useState } from 'react';
import { useGetApiData } from '@grc/ui-utility';
import { GetQuoteSettings } from '../../service/api/get-quotes-service';

export interface IQuoteTransportationMode {
  id: number;
  displayName?: string;
}

export interface IQuoteHandlingUnitType {
  id: string;
  name?: string;
}

// Temporary stand-in for real account context, which isn't wired up in this
// portal build yet - matches the same approach used by the Documents page.
const STATIC_PORTAL_ACCOUNT_ID = '8ae34d04-c0d4-47b1-938c-2e991b35eb5e';

// GET /quotes/settings once for the page's lifetime (not per-tab-switch).
// Confirmed against a real response: TransportationModeDetails/
// HandlingUnitTypeDetails both come back lowercase (id/displayName,
// id/name) - the Mode column needs a modeId -> name join since
// TransportationModeId isn't inlined as a display string on the row DTO
// (plan §5 gap 4, §10), and HuProduct needs a handlingUnitTemplateId -> name
// join the same way.
export function useQuoteSettings() {
  const { fetchData } = useGetApiData();
  const [transportationModes, setTransportationModes] = useState<
    IQuoteTransportationMode[]
  >([]);
  const [handlingUnitTypes, setHandlingUnitTypes] = useState<
    IQuoteHandlingUnitType[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isCancelled = false;

    const load = async () => {
      setIsLoading(true);
      const settings = await GetQuoteSettings(
        fetchData,
        STATIC_PORTAL_ACCOUNT_ID
      );
      if (!isCancelled) {
        setTransportationModes(settings?.TransportationModeDetails ?? []);
        setHandlingUnitTypes(settings?.HandlingUnitTypeDetails ?? []);
        setIsLoading(false);
      }
    };

    load();

    return () => {
      isCancelled = true;
    };
  }, [fetchData]);

  return { transportationModes, handlingUnitTypes, isLoading };
}

export default useQuoteSettings;
